import React, { useContext, useEffect, useState } from 'react';

import { GridRowParams, GridValueFormatterParams } from '@mui/x-data-grid';

import CustomDataGrid from '../../components/data-grid';
import { AppContext } from '../../contexts/app-context';
import GlobalStyles from '../../global-styles';
import SKUCRUD from '../../screens/onboarding/crud/sku-crud';
import { formatDateForDataGrid } from '../../utils/helper';
import { Box } from '../../utils/material-ui-core';

interface SKUListProps {
  showNew: boolean;
  sku: string;
}

const SKUList = ({ showNew, sku }: SKUListProps) => {
  const globalStyles = GlobalStyles();

  const { writeLog, skus, setOnboardingPagePathName } = useContext(AppContext);

  const [skuKey, setSKUKey] = useState<string>("");
  const [skuEditDialogOpen, setSKUEditDialogOpen] = useState<boolean>(false);
  const [backToProgram360, setbackToProgram360] = useState<boolean>(false);

  const columns = [
    { field: "partNumber", headerName: "SKU", width: 250 },
    { field: "name", headerName: "Name", width: 300 },
    {
      field: "fulfillable",
      headerName: "Fulfillable",
      width: 180,
      type: "boolean",
    },
    { field: "isDevice", headerName: "Device", width: 180, type: "boolean" },
    {
      field: "nodeReferenceName",
      headerName: "Node Name",
      width: 250,
      hide: true,
    },
    { field: "vendorName", headerName: "Vendor Name", width: 250, hide: true },
    { field: "kitCount", headerName: "Kit Count", width: 150, type: "number" },
    {
      field: "enrollmentCount",
      headerName: "# Enrolled",
      width: 150,
      type: "number",
      hide: false,
    },
    {
      field: "lastModifiedBy",
      headerName: "Last Modified By",
      width: 250,
      hide: true,
    },
    {
      field: "lastModifiedDateTime",
      headerName: "Last Modified Date",
      width: 200,
      type: "dateTime",
      valueFormatter: (params: GridValueFormatterParams) => formatDateForDataGrid(params.value as string),
    },
    {
      field: "skuKey",
      headerName: "Key",
      width: 400,
      filterable: false,
      hide: true,
    },
  ];

  const handleDataGridClick = (params: GridRowParams, event: any) => {
    const filterSKU = skus.filter((skus) => skus.skuKey === params.row.skuKey);
    if (filterSKU.length > 0) {
      writeLog("Onboarding Page", "Opening sku detail.", filterSKU[0].skuKey, "sku");
      editSKU(filterSKU[0]);
    }
  };

  const getData = () => {
    const rows: any = [];
    skus.map((sku, index) => rows.push({ id: index, ...sku }));
    return rows;
  };

  const newSKU = () => {
    setSKUKey("");
    setSKUEditDialogOpen(true);
  };

  const editSKU = (sku: SKU) => {
    setSKUKey(sku.skuKey);
    setSKUEditDialogOpen(true);
  };

  const skuEditDialogResult = (confirmOutput: ConfirmOutput) => {
    setSKUEditDialogOpen(false);
    if (backToProgram360) {
      setOnboardingPagePathName("Program 360");
      return;
    }
  };

  useEffect(() => {
    if (showNew) {
      if (sku !== undefined && sku !== null && sku === "") {
        newSKU();
        setbackToProgram360(false);
      } else if (sku !== undefined && sku !== null && sku !== "") {
        const filterSKUs = skus.filter((item) => item.partNumber.toLowerCase() === sku.toLowerCase());

        if (filterSKUs !== null && filterSKUs.length === 1) {
          editSKU(filterSKUs[0]);
          setbackToProgram360(true);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showNew, sku]);

  return (
    <>
      <SKUCRUD open={skuEditDialogOpen} skuKey={skuKey} onCallback={skuEditDialogResult} />

      <Box className={globalStyles.onboardingDatagridContainer}>
        <CustomDataGrid uniqueGridCode={"SKUListResult"} columns={columns} rows={getData()} showToolBar={true} sortModel={[{ field: "partNumber", sort: "asc" }]} handleDataGridClick={handleDataGridClick} />
      </Box>
    </>
  );
};

export default SKUList;
